import styles from "./Avatar.module.css";

export default function Avatar({ imageUrl, name, seed, size = 44, accent }) {
  const label = (name || seed || "").trim();

  if (imageUrl) {
    return (
      <img
        className={styles.avatar}
        style={{ "--avatar-size": `${size}px`, "--avatar-accent": accent || "var(--border-md)" }}
        src={imageUrl}
        alt=""
        width={size}
        height={size}
      />
    );
  }

  return (
    <span
      className={styles.generated}
      style={{ "--avatar-size": `${size}px`, "--avatar-accent": accent || "var(--amber)" }}
      aria-hidden="true"
    >
      {label.charAt(0).toUpperCase() || "?"}
    </span>
  );
}
